import { render, staticRenderFns } from "./video-scriptwriter.vue?vue&type=template&id=84e8e08c&scoped=true&"
import script from "./video-scriptwriter.vue?vue&type=script&lang=js&"
export * from "./video-scriptwriter.vue?vue&type=script&lang=js&"
import style0 from "./video-scriptwriter.vue?vue&type=style&index=0&id=84e8e08c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e8e08c",
  null
  
)

export default component.exports